import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import ue from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { convertMsToSeconds as l } from "../util/date-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";

var Lt = /*#__PURE__*/function () {
  function Lt(s, t, e, i) {
    _classCallCheck(this, Lt);

    this.h = s, this.v = t, this.gt = e, this.sh = 1e3, i = parseFloat(i), isNaN(i) && (i = 1800), i < this.sh / 1e3 && (r.D.info("Specified session timeout of " + i + "s is too small, using the minimum session timeout of " + this.sh / 1e3 + "s instead."), i = this.sh / 1e3), this.eh = i;
  }

  _createClass(Lt, [{
    key: "ih",
    value: function ih(s, t) {
      return new ue(this.v.getUserId(), r.A.nh, s, t.eu, {
        d: l(s - t.rh)
      });
    }
  }, {
    key: "Vo",
    value: function Vo() {
      var s = this.h.tu(o.iu.oh);
      return null == s ? null : s.eu;
    }
  }, {
    key: "hh",
    value: function hh() {
      var s = new Date().valueOf(),
          t = this.gt.Fl(),
          e = this.h.I(o.q.lh);
      if (null != e && null == t) return !1;
      var i = null == e || s - e > 1e3 * t;
      return i && this.h.B(o.q.lh, s), i;
    }
  }, {
    key: "uh",
    value: function uh(s, t) {
      return null == t || !(s - t.rh < this.sh) && t.ah < s;
    }
  }, {
    key: "mo",
    value: function mo() {
      var s = new Date().valueOf(),
          t = s + 1e3 * this.eh,
          e = this.h.tu(o.iu.oh);

      if (this.uh(s, e)) {
        var i = "Generating session start event with time " + s;

        if (null != e) {
          var _s = e.mh;
          _s - e.rh < this.sh && (_s = e.rh + this.dh), this.h.fh(this.ih(_s, e)), i += " (old session ended " + _s + ")";
        }

        i += ". Will expire " + t.valueOf(), r.D.info(i);
        var n = new _t(r.it.nt(), t);
        this.h.fh(new ue(this.v.getUserId(), r.A.ph, s, n.eu)), this.h.ru(o.iu.oh, n);
        return null == this.h.I(o.q.lh) && this.h.B(o.q.lh, s), n.eu;
      }

      return e.mh = s, e.ah = t, this.h.ru(o.iu.oh, e), e.eu;
    }
  }, {
    key: "gh",
    value: function gh() {
      var s = this.h.tu(o.iu.oh);
      null != s && (this.h.wh(o.iu.oh), this.h.fh(this.ih(new Date().valueOf(), s)));
    }
  }]);

  return Lt;
}();

export { Lt as default };